import * as animationData from '@/assets/lottie/loader.json'

export function getData() {
  return { animationData: animationData.default, id: 'lottieLoader', className: 'lottie-grid-load' }
}
